import { Icon } from "@src/straps/base";
import { IconNames } from "@src/straps/base/icons/Icon/types";
import Text from "../../base/type/Text/Text";

const WarningMessage = ({
  message = "Something went wrong. Please contact Backpack support if the problem persists.",
  icon = "warning",
  height = 288,
}: {
  readonly message?: string;
  readonly icon?: IconNames;
  readonly height?: number;
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center text-center"
      style={{ height: `${height}px` }}
    >
      <Icon name={icon} className="mb-8 !h-10 !w-10" color="secondary" />
      <Text variant="sb_t-14-500" color="secondary">
        {message}
      </Text>
    </div>
  );
};

export default WarningMessage;
